/**
 * Where the Encuentro tokens (`--en-*`) apply.
 *
 * The variables exist only under `[data-ui='encuentro']`. F1/F7 put that
 * attribute on `<html>` when `getUiVersion()` resolves to `encuentro`, so the
 * whole document is in scope, Radix portals included (they mount in `<body>`).
 * In classic mode nothing carries the attribute: no `--en-*` variable is
 * defined and the current UI does not change.
 *
 * The dark theme is `data-theme='dark'` on the same element or on a
 * descendant; `data-theme='light'` on a descendant restores light (useful for
 * a side-by-side catalog). The product ships in light.
 *
 * `scripts/design/build-tokens.ts` (the generated CSS) and
 * `lib/design/accent.ts` (the per-institution accent) both read these
 * selectors, so the scope is defined once.
 */
export const ENCUENTRO_SCOPE_ATTRIBUTE = 'data-ui'
export const ENCUENTRO_SCOPE_VALUE = 'encuentro'
export const ENCUENTRO_THEME_ATTRIBUTE = 'data-theme'

export type EncuentroTheme = 'light' | 'dark'

const scope = `[${ENCUENTRO_SCOPE_ATTRIBUTE}='${ENCUENTRO_SCOPE_VALUE}']`
const theme = (t: EncuentroTheme) => `[${ENCUENTRO_THEME_ATTRIBUTE}='${t}']`

/** Light tokens: the scope root, or a light island inside it. */
export const ENCUENTRO_LIGHT_SELECTOR = `${scope}, ${scope} ${theme('light')}`

/** Dark tokens: dark on the scope root itself, or a dark island inside it. */
export const ENCUENTRO_DARK_SELECTOR = `${scope}${theme('dark')}, ${scope} ${theme('dark')}`

export function encuentroSelector(t: EncuentroTheme): string {
  return t === 'dark' ? ENCUENTRO_DARK_SELECTOR : ENCUENTRO_LIGHT_SELECTOR
}
